import { render, staticRenderFns } from "./Ramp.vue?vue&type=template&id=1cf3aea1&scoped=true"
import script from "./Ramp.vue?vue&type=script&lang=js"
export * from "./Ramp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf3aea1",
  null
  
)

export default component.exports